import type { ApiClient } from '../index'
import type {
  MissionTemplate,
  MetricSample,
  TeamBudget,
  EnableTemplateResult,
} from './types'

// NOTE: ApiClient.baseUrl already contains the `/teamofone` global prefix
// (configured via VITE_TEAMOFONE_API_URL — e.g. `http://localhost:6055/teamofone`
// in dev or `/teamofone` in prod). Each call here must use a bare resource
// path or the resulting URL gets a double `/teamofone/teamofone/...` prefix
// and the BE returns 404.
export function createMissionsApi(client: ApiClient) {
  return {
    async listTemplates(): Promise<{ templates: MissionTemplate[] }> {
      return client.get('/missions/templates')
    },

    async getTemplate(templateId: string): Promise<MissionTemplate> {
      return client.get(`/missions/templates/${templateId}`)
    },

    async enableTemplate(
      templateId: string,
      params: Record<string, unknown>,
    ): Promise<EnableTemplateResult> {
      return client.post(`/missions/templates/${templateId}/enable`, {
        params,
      })
    },

    async getMetricSamples(
      missionId: string,
      limit = 30,
    ): Promise<{ samples: MetricSample[] }> {
      return client.get(
        `/missions/${missionId}/metric-samples?limit=${limit}`,
      )
    },

    async getBudget(): Promise<TeamBudget> {
      return client.get('/missions/budget')
    },
  }
}
